import { useTranslation } from "react-i18next";
import { useGetMyWorkerLeaveReportQuery } from "../api/workContractApiSlice";
import { useEffect } from "react";

export default function MyLeaveHoursLeft(
    {
        forceRefresh = false
    }
) {

    const [t] = useTranslation(["global", "absenceReport"])

    const {
        data: leaveReport,
        isSuccess,
        isError,
        isLoading,
        isFetching,
        error,
        refetch
    } = useGetMyWorkerLeaveReportQuery()

    useEffect(() => {
        if (forceRefresh) {
            refetch()
        }
    }, [forceRefresh])

    function getColor(value) {
        if (value > 0) {
            return "text-accent"
        } else return "text-danger"

    }

    let content;

    if (isSuccess) {
        content = (
            <div className="card bg-dark mb-4">
                <div className="card-body text-center">
                    <div className="row">
                        <div className="col">
                            <span >{t("absenceReport:property.available_leave_time")}</span>
                            <br />
                            <h4 className="my-3"><b className={getColor(leaveReport.holidays.available)}>{roundNumber(leaveReport.holidays.available, 1)}</b> {t("unit.hours")} <i className="fa-solid fa-umbrella-beach"></i> </h4>
                            <span className="text-muted">Contabile  {roundNumber(leaveReport.holidays.balance, 2)}</span><br />
                            <span className="text-muted">Prenot.  {roundNumber(leaveReport.holidays.toTake, 2)}</span>
                        </div>
                        <div className="col">
                            <span>Permessi disponibili</span>
                            <br />
                            <h4 className="my-3"><b className={getColor(leaveReport.timeOff.available + leaveReport.abolished.available)}>{roundNumber(leaveReport.timeOff.available + leaveReport.abolished.available, 1)}</b> {t("unit.hours")} <i className="fa-regular fa-clock"></i></h4>
                            <span className=" text-muted">Contabile  {roundNumber(leaveReport.timeOff.balance + leaveReport.abolished.balance, 2)}</span><br />
                            <span className=" text-muted">Prenot.  {roundNumber(leaveReport.timeOff.toTake + leaveReport.abolished.toTake, 2)}</span>
                        </div>
                    </div>


                </div>

            </div>

        )
    }

    return content

}

function roundNumber(num, scale) {
    if (!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + scale) + "e-" + scale);
    } else {
        var arr = ("" + num).split("e");
        var sig = ""
        if (+arr[1] + scale > 0) {
            sig = "+";
        }
        return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
}